import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Envelope } from '../../interfaces/envelope';
import { Device } from '../../interfaces/devices';
import { devicesService } from '../services/devices.service';

interface DevicesState {
	devices: {
		[id: number]: Device;
	};
	isLoading: boolean;
}

const initialState = {
	devices: [],
	isLoading: false,
} as DevicesState;

export const fetchDevicesCategory = createAsyncThunk<
	Device[],
	string,
	{
		rejectValue: Envelope<[]> | unknown;
	}
>('devices/fetchDevicesCategory', async (category, { rejectWithValue }) => {
	try {
		return await devicesService.fetchDevicesCategory(category);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const devicesSlice = createSlice({
	name: 'devices',
	initialState,
	reducers: {
		resetDevices: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDevicesCategory.fulfilled, (state, action) => {
			const ret: { [id: number]: Device } = {};
			state.devices = action.payload.reduce((obj, device) => {
				obj[device.id] = device;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchDevicesCategory.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDevicesCategory.rejected, (state, action) => {
			state.devices = [];
			state.isLoading = false;
		});
	},
});

export const { resetDevices } = devicesSlice.actions;

export default devicesSlice;
